import { render, staticRenderFns } from "./box-single-top.vue?vue&type=template&id=acf21f78&scoped=true&"
import script from "./box-single-top.vue?vue&type=script&setup=true&lang=ts&"
export * from "./box-single-top.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./box-single-top.vue?vue&type=style&index=0&id=acf21f78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf21f78",
  null
  
)

/* custom blocks */
import block0 from "./box-single-top.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports